import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const LocationFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M18.06 7.53c-.33-1.76-1.34-3.32-2.79-4.27-1.72-1.14-3.95-1.35-5.81-.54-1.61.7-2.77 2.04-3.25 3.77-.58 2.09-.13 4.52 1.18 6.35l3.96 5.55.26.33h.8l4.21-5.7c1.25-1.79 1.77-3.73 1.44-5.48v-.01ZM12 11.75c-1.86 0-3.37-1.51-3.37-3.37S10.14 5.01 12 5.01s3.37 1.51 3.37 3.37-1.51 3.37-3.37 3.37Z" />
      <Path d="M12 6.52c-1.03 0-1.87.84-1.87 1.87 0 1.03.84 1.87 1.87 1.87 1.03 0 1.87-.84 1.87-1.87 0-1.03-.84-1.87-1.87-1.87ZM12.04 21.75c-.14 0-.27-.04-.39-.11l-5.2-3.2a.754.754 0 0 1-.36-.62c0-.25.12-.49.33-.64l1.79-1.22c.34-.23.81-.14 1.04.2.23.34.14.81-.2 1.04l-.83.57 3.83 2.36 3.85-2.22-1.01-.71a.743.743 0 0 1-.18-1.04c.24-.34.71-.42 1.04-.18l1.97 1.39a.757.757 0 0 1-.05 1.27l-5.26 3.03c-.12.07-.25.1-.37.1v-.02Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default LocationFilled
